import { createStore } from 'owa-satcheljs';

/**
 * Tracks which custom search folders have a restriction that limits them to unread items.
 * Custom search folders created by OWA use SearchFolderTemplateId.CUSTOM, so the template id
 * alone cannot tell us whether reading an item will drop it from the folder.
 */
export interface UnreadSearchFolderStore {
    searchFolderHasUnreadRestriction: Record<string, boolean>;
}

const defaultStore: UnreadSearchFolderStore = {
    searchFolderHasUnreadRestriction: {},
};

export const getUnreadSearchFolderStore: () => UnreadSearchFolderStore =
    createStore<UnreadSearchFolderStore>('unreadSearchFolderStore', defaultStore);

/**
 * Returns whether the search folder's restriction requires items to be unread,
 * or undefined if the restriction has not been loaded yet.
 */
export function getSearchFolderHasUnreadRestriction(searchFolderId: string): boolean | undefined {
    return getUnreadSearchFolderStore().searchFolderHasUnreadRestriction[searchFolderId];
}
